import { recycleRight } from '../constants';

/**
 * Import constants
 */
const {
  SET_SWIPER_LEVEL,
  SET_DONE_MATERIAL,
  REMOVE_DONE_MATERIAL,
  SET_WHOLE_RECYCLE_RIGHT,
  SET_RECYCLE_RIGHT_DATA
} = recycleRight;

/**
 * Action creators
 */

const actions = {
  setWhole: (data) => ({ type: SET_WHOLE_RECYCLE_RIGHT, data })
};

/**
 * Set discovery data
 */
export const setRecycleRightData = (data) => (dispatch) => dispatch(
  actions.setRecycleRightData(data)
);

/**
 * Update discovery data from mobile app
 */
export const setWhole = (data) => (dispatch) => dispatch(actions.setWhole(data));

// export const setRecycleRightData = (data) => (dispatch) => dispatch({
//   type: SET_RECYCLE_RIGHT_DATA, data: discoveryReducer(data)
// });

export const setDoneMaterial = (data) => (dispatch) => dispatch({ type: SET_DONE_MATERIAL, data });

export const removeDoneMaterial = (
  data
) => (dispatch) => dispatch({ type: REMOVE_DONE_MATERIAL, data });

export const setSwiperCurrentLevel = (data) => (dispatch) => dispatch({
  type: SET_SWIPER_LEVEL,
  data
});
